import { create } from "zustand";
import type { LabelMatchMode } from "./labelFilter.store.js";

/** Transient (not persisted) view filter: which topics are selected in the
 *  sidebar tree and whether a task must match ANY or ALL of them. Empty
 *  selection means "no filter". Mirrors {@link useLabelFilterStore}; read by the
 *  view-filter chain via `filterByTopics` in lib/view-filters.ts. */
interface TopicFilterState {
  selected: string[];
  mode: LabelMatchMode;
  toggle: (id: string) => void;
  clear: () => void;
  setMode: (mode: LabelMatchMode) => void;
}

export const useTopicFilterStore = create<TopicFilterState>((set, get) => ({
  selected: [],
  mode: "any",
  toggle(id) {
    const selected = get().selected;
    set({ selected: selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id] });
  },
  clear() { set({ selected: [] }); },
  setMode(mode) { set({ mode }); },
}));
